import { useState } from "react";
import { useTranslation } from "react-i18next";

type Data = {
  content: string;
  subCategoryCount: number;
  id: number;
};

interface ItemProps {
  selected?: boolean;
  isHeader?: boolean;
  data?: Data;
  onClick?: () => void;
}

interface SidebarProps {
  className?: string;
  onAccessmentInfoSelect?: () => void;
  onCategorySelect?: (selectedId?: number) => void;
  items: ItemProps[];
}
function ItemContainer({ selected, isHeader, data, onClick }: ItemProps) {
  const { t } = useTranslation();
  return (
    <div
      onClick={onClick}
      className={`p-3 my-1 cursor-pointer transition-colors duration-300 hover:bg-cool-gray-200 hover:rounded-lg ${selected ? "bg-cool-gray-100 rounded-lg" : "bg-white"} ${isHeader ? "border-b border-cool-gray-200" : ""}`}
    >
      {isHeader ? (
        <HeaderItem selected={selected} />
      ) : (
        <SidebarItem selected={selected} data={data} />
      )}
    </div>
  );
}

function HeaderItem({ selected = false }: { selected?: boolean }) {
  const { t } = useTranslation();
  const labelColor = selected ? "text-cool-gray-700" : "text-cool-gray-600";
  return (
    <div className="flex flex-col space-y-1">
      <p className="text-sm font-medium text-cool-gray-700">
        {t("assessment-info")}
      </p>
      <p className={`text-sm font-normal ${labelColor}`}>
        {t("company-details-and-files")}
      </p>
    </div>
  );
}

function SidebarItem({
  selected = false,
  data,
}: {
  selected?: boolean;
  data?: Data;
}) {
  const { t } = useTranslation();
  const labelColor = selected ? "text-cool-gray-700" : "text-cool-gray-600";
  return (
    <div className="flex flex-col space-y-1">
      <p className={`text-sm font-medium ${labelColor}`}>{data?.content}</p>
      <p
        className={`text-sm font-normal ${labelColor}`}
      >{`${data?.subCategoryCount} ${t("sub-categories")}`}</p>
    </div>
  );
}

function Sidebar({
  className = "",
  onAccessmentInfoSelect,
  onCategorySelect,
  items,
}: SidebarProps) {
  const [sidebarItems, setSidebarItems] = useState(
    items.map((item) => ({ ...item, selected: item.isHeader })),
  );

  const handleItemClick = (index: number) => {
    setSidebarItems((prevItems) =>
      prevItems.map((item, i) => {
        if (i === index) {
          return { ...item, selected: true };
        }
        return { ...item, selected: false };
      }),
    );

    if (index === 0) {
      onAccessmentInfoSelect?.();
    } else {
      if (items[index].data?.id) onCategorySelect?.(items[index].data?.id);
    }
  };

  return (
    <div
      className={`${className} flex flex-col w-[280px] p-4 bg-white flex-shrink-0 border-r-[2px] border-r-cool-gray-200`}
    >
      {sidebarItems.map((item, index) => (
        <ItemContainer
          onClick={() => {
            handleItemClick(index);
          }}
          key={index}
          {...item}
        />
      ))}
    </div>
  );
}

export default Sidebar;
